import React from 'react'
import Skeleton from 'react-loading-skeleton'

import ActionsCell from './ActionsCell'

const ActionsCol = ({ classes, formik, editProductId, allowAutoSave, handleDeleteProduct, handleEditProduct }) => {
  return {
    style: { minWidth: 56, maxWidth: 56, height: '100%', padding: 0, justifyContent: 'flex-end' },
    header: 'action',
    headClassName: classes.actionsHeader,
    Cell: (productValues, productIndex) => {
      const isProductLoading = productValues.isLoading

      return isProductLoading ? (
        <Skeleton width="100%" />
      ) : (
        <ActionsCell
          formik={formik}
          productIndex={productIndex}
          productValues={productValues}
          editProductId={editProductId}
          allowAutoSave={allowAutoSave}
          handleDeleteProduct={handleDeleteProduct}
          handleProductEdit={handleEditProduct}
        />
      )
    }
  }
}

export default ActionsCol
